import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal } from 'components';
import { CleanIcon, TrashIcon, EditIcon, AddIcon, ViewIcon, CheckGreenIcon, CloseIcon } from 'assets/icons';
import ModalCreate from './modal-create';
import ModalView from './modal-view';
import { SurveyService } from 'services';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	status_finish: '',
	status: '',
	expiration_date: '',
	since: '',
	until: ''
}

class AdminSurveys extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Fecha de Creación',
			'Nombre',
			'Preguntas',
			'Respuestas',
			'Fecha de Expiración',
			'Estatus de Finalización',
			'Estatus',
			'Acciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null,
		visible_view: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Encuestas',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await SurveyService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
			expiration_date: this.state.form.expiration_date && moment(this.state.form.expiration_date).format('YYYY-MM-DD'),
		});
		this.setState({
			data: res.surveys.rows,
			last_page: res.surveys.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	view = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_view: true,
			item
		});
	}

	delete = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la encuesta?',async () => {
			await SurveyService.admin.delete({
				survey_id: item.id
			});
			this.load(true);
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	onCloseView = () => {
		this.setState({
			visible_view: false,
			item: null
		});
	}

	changeStatus = (e: any, item: any) => {
		e.preventDefault();
		const { ACTIVE, INACTIVE } = Constants.SURVEY_STATUS;
		Globals.confirm(`¿Cambiar el estatus de la encuesta a ${ item.status == ACTIVE ? 'Inactiva' : 'Activa' }?`,async () => {
			await SurveyService.admin.changeStatus({
				survey_id: item?.id
			});
			this.load(true);
			Globals.showSuccess("Se ha cambiado el estatus correctamente");
		})
	}
	
	render() {
		const { visible, visible_view } = this.state;
		const { ACTIVE, INACTIVE } = Constants.SURVEY_STATUS;

		return (
			<div id="admin-surveys">
		      	<Modal
		          className="modal-create-survey"
		          visible={ visible }
		          title={ `${ this.state.item ? 'Editar' : 'Crear' } encuesta` }
		          onClose={ () => this.onClose() }
		        >
		          <ModalCreate
		            item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<Modal
		          className="modal-view-survey"
		          visible={ visible_view }
		          // @ts-ignore
		          title={ this.state.item?.name }
		          onClose={ () => this.onCloseView() }
		        >
		          <ModalView
		            item={ this.state.item }
		            onClose={ () => this.onCloseView() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-11">
						<div className="row">
							<div className="col-md">
								<Input
									value={ this.state.form.search }
									name="search"
									placeholder="Buscar"
									label="Nombre"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md">
								<DatePicker
									label="Desde"
									placeholder="Desde"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'since'
											}
										},() => this.load(true));
									} }
									value={ this.state.form.since }
								/>
							</div>
							<div className="col-md">
								<DatePicker
									label="Hasta"
									placeholder="Hasta"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'until'
											}
										},() => this.load(true));
									} }
									value={ this.state.form.until }
								/>
							</div>
							<div className="col-md">
								<DatePicker
									label="Fecha de expiración"
									placeholder="Fecha"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'expiration_date'
											}
										},() => this.load(true));
									} }
									value={ this.state.form.expiration_date }
								/>
							</div>
							<div className="col-md">
								<Select
									placeholder="Seleccionar"
									label="Estatus (Finalización)"
									name="status_finish"
									color="white"
									onChange={ (e: any) => this.change(e,async () => {
										this.load(true);
									}) }
									value={ this.state.form.status_finish }
									options={ [
										{ value: Constants.SURVEY_STATUS.ONGOING.toString() , label: 'En Proceso' },
										{ value: Constants.SURVEY_STATUS.FINISH.toString() , label: 'Finalizadas' },
									] } />
							</div>
							<div className="col-md">
								<Select
									placeholder="Seleccionar"
									label="Estatus"
									name="status"
									color="white"
									onChange={ (e: any) => this.change(e,async () => {
										this.load(true);
									}) }
									value={ this.state.form.status }
									options={ [
										{ value: Constants.SURVEY_STATUS.ACTIVE.toString() , label: 'Activas' },
										{ value: Constants.SURVEY_STATUS.INACTIVE.toString() , label: 'Inactivas' },
									] } />
							</div>
						</div>
					</div>
					<div className="col-md-1">
						{
							this.state.form != INITIAL_STATE && (
								<button className="btn btn-clean" onClick={ () => this.reset() }>
									<img src={ CleanIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table title="Encuestas" data={ this.state.data.length } header={ this.state.header } titleRight={
					<>
						{
							checkPermission(Constants.MODULES.SURVEYS,'write') && (
								<div className="container-add-table">
									<p>Nuevo</p>
									<button className="btn add-btn-table" onClick={ () => this.add() }>
										<img src={ AddIcon } />
									</button>
								</div>
							)
						}
					</>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ moment(i.created_at).format('DD/MM/YYYY') }</td>
								<td>{ i?.name }</td>
								<td>{ i?.questions_quantity }</td>
								<td>{ i?.responses_quantity }</td>
								<td>{ moment(i.expiration_date).format('DD/MM/YYYY') }</td>
								<td>{ i.status_finish_text }</td>
								<td>{ i.status_text }</td>
								<td>
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={ (e: any) => this.view(e,i) }>
											<img src={ ViewIcon } />
										</a>
									</Tooltip>
									<Tooltip title={ i.status == ACTIVE ? 'Desactivar' : 'Activar' }>
										<a className="link-icon link-status" href="#" onClick={ (e: any) => this.changeStatus(e,i) }>
											<img src={ i.status == Constants.SURVEY_STATUS.ACTIVE ? CloseIcon : CheckGreenIcon } />
										</a>
									</Tooltip>
									{
										checkPermission(Constants.MODULES.SURVEYS,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.SURVEYS,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(AdminSurveys);